import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getInstituteTestPricingUploadMasterApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}test-price/get-test-upload-data`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getInstituteTestPricingUploadMasterApi